import { IMarketClassifiedSmartfolios } from "src/interfaces/ClassifiedSmartfolios";
import { userInterface } from "src/interfaces/Client";
import {
  SUGGESTED_ALLOCATION as riskProfile,
  riskAppetite as getClientType,
  suggestedAllocation,
} from "src/utils/products";

const activeStatus = ["Open", "Exiting"];

/* The table and the bands moved to utils/products, where both pages that
   read them can. Aliased on import so the arithmetic below reads as it
   always did. */

export const getCurrentLayerPercentageColor = (percentage, score, layer) => {
  return riskProfile[layer][getClientType(score)] - 5 < percentage &&
    percentage < riskProfile[layer][getClientType(score)] + 5
    ? "#00c92f"
    : "#f2a20c";
};

export const getRiskProfileDetails = ({
  values,
  positions,
  data,
  user,
}: {
  values: any;
  positions: any;
  data: IMarketClassifiedSmartfolios;
  user: userInterface;
}) => {
  const score = user?.data?.riskProfile?.spiderWebScore?.totalScore;

  if (data && positions && values.layer && values.smartfolio) {
    const { smartfolio } = values;
    const currentSmartfolio = data?.All.assetClass.All.smartfolio?.find(
      (a) => a.name === smartfolio,
    );
    if (!currentSmartfolio) return;

    const { layer: currentLayer, assetClass: currAssetClass } =
      currentSmartfolio;

    const activePositions = positions.filter((elm) =>
      activeStatus.includes(elm.status),
    );

    const activePositionsNav = activePositions.reduce(
      (acc, cur) => acc + cur.investmentNAV,
      0,
    );

    const currentLayerActivePositions = activePositions.filter(
      (elm) => elm.layer === currentLayer,
    );

    const currentLayerActivePositionsNav = currentLayerActivePositions.reduce(
      (acc, cur) => acc + cur.investmentNAV,
      0,
    );

    const currentLayerPercentage =
      activePositionsNav === 0
        ? 0
        : Math.abs((currentLayerActivePositionsNav / activePositionsNav) * 100);

    const color = getCurrentLayerPercentageColor(
      currentLayerPercentage,
      score,
      currentLayer,
    );

    const suggestedPercentage = suggestedAllocation(currentLayer, score);

    return {
      currentLayer,
      currentLayerNav: currentLayerActivePositionsNav,
      currentLayerPercentage: Number(currentLayerPercentage).toFixed(0),
      suggestedPercentage,
      color,

      activePosionsNav: activePositionsNav,
      currAssetClass,
    };
  }
};
